import { render } from "./audioPlayer3.vue?vue&type=template&id=44c34bdd&scoped=true"
import script from "./audioPlayer3.vue?vue&type=script&lang=js"
export * from "./audioPlayer3.vue?vue&type=script&lang=js"

import "./audioPlayer3.vue?vue&type=style&index=0&id=44c34bdd&lang=scss&scoped=true"
import "./audioPlayer3.vue?vue&type=style&index=1&id=44c34bdd&lang=scss"
script.render = render
script.__scopeId = "data-v-44c34bdd"

export default script